import { AfterViewInit, Component, Input, NgModule, OnChanges, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxScrollViewModule } from 'devextreme-angular/ui/scroll-view';
import { routerTransition } from 'src/app/shared/services/animations';
import { FooterModule, HeaderModule } from 'src/app/shared/components';
import { APIConfing } from 'src/app/shared/services/apiconfing.service';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-single-card',
  templateUrl: './single-card.component.html',
  styleUrls: ['./single-card.component.scss'],
  standalone: false,
  /* ,
  animations: [routerTransition()] */
})
export class SingleCardComponent implements OnInit, OnChanges, AfterViewInit {
  isWhiteLabled: any;
  isCareerPortal: boolean = false;
  isSinglePage = false;
  selRoute: any;
  isSelfOnboardProtal = false;
  footerLink: any;
  footerText: any;
  footerImg: any;
  constructor(private pageTitle: Title, private route: Router) {
    if (APIConfing.data.isWhiteLabled != 'No')
      pageTitle.setTitle(APIConfing.data.isWhiteLabled);
    this.isWhiteLabled = APIConfing.data.isWhiteLabled;
    this.footerLink = APIConfing.data.footerConfig.footerLink;
    this.footerText = APIConfing.data.footerConfig.footerText;
    this.footerImg = APIConfing.data.footerConfig.footerImg;
    // route.events.subscribe(val => {
    //   if (val instanceof NavigationEnd) {
    //     const selectedRoute = val.urlAfterRedirects.split('?')[0];
    //     if (selectedRoute && selectedRoute === '/job-details' || selectedRoute === '/apply-for-job' || selectedRoute === '/jobs' || selectedRoute === '/token' || selectedRoute === '/Resume-List' || selectedRoute === '/Interview-Feedback' || selectedRoute === '/Timesheet-Approval' || selectedRoute === '/Pay-Register' || selectedRoute === '/early-attendance') {
    //       this.isCareerPortal = true;
    //     }
    //     else {
    //       this.isCareerPortal = false;
    //     }
    //   }
    // });
    if (this.route.url === '/login') {
      this.isCareerPortal = false;
      this.isSelfOnboardProtal = false;
      this.isSinglePage = true;
      this.selRoute = this.route.url;
    }
    this.route.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((e: any) => {
      setTimeout(() => {
        const selectedRoute = e.urlAfterRedirects.split('?')[0];
        this.selRoute = selectedRoute;
        if (selectedRoute) {
          if (selectedRoute && selectedRoute === '/associate-registration' || selectedRoute === '/job-details' || selectedRoute === '/apply-for-job' || selectedRoute === '/jobs' || selectedRoute === '/token' || selectedRoute === '/Resume-List' || selectedRoute === '/Interview-Feedback' || selectedRoute === '/Timesheet-Approval' || selectedRoute === '/Pay-Register' || selectedRoute === '/early-attendance' || selectedRoute === '/self-onboarding' || selectedRoute === '/folder-doc' || selectedRoute === '/TSApprove' || selectedRoute === '/LeaveApprove' || selectedRoute === '/RimApprove' || selectedRoute === '/CompOffApproval' || selectedRoute === '/MissPunchApproval' || selectedRoute === '/RequirementApprove' || selectedRoute === '/EmployeeInfo' || selectedRoute === '/Display-Details' || selectedRoute === '/LoanApprove') {
            this.isCareerPortal = true;
            this.isSinglePage = false;
            this.isSelfOnboardProtal = false;
          }
          else {
            const self = selectedRoute.split('/')[1];
            if (self && self === 'self-onboarding') {
              this.isSelfOnboardProtal = true;
              this.isCareerPortal = false;
              this.isSinglePage = true;
            }
            else {
              this.isCareerPortal = false;
              this.isSelfOnboardProtal = false;
              this.isSinglePage = false;
            }
          }
        }
      }, 100);
    });

  }
  ngOnInit() {
  }
  ngOnChanges() {
    if (this.route.url === '/login') {
      this.isCareerPortal = false;
      this.isSelfOnboardProtal = false;
      this.isSinglePage = true;
      this.selRoute = this.route.url;
    }
    this.route.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((e: any) => {
      setTimeout(() => {
        const selectedRoute = e.urlAfterRedirects.split('?')[0];
        this.selRoute = selectedRoute;
        if (selectedRoute) {
          if (selectedRoute && selectedRoute === '/associate-registration' || selectedRoute === '/job-details' || selectedRoute === '/apply-for-job' || selectedRoute === '/jobs' || selectedRoute === '/token' || selectedRoute === '/Resume-List' || selectedRoute === '/Interview-Feedback' || selectedRoute === '/Timesheet-Approval' || selectedRoute === '/Pay-Register' || selectedRoute === '/early-attendance' || selectedRoute === '/self-onboarding' || selectedRoute === '/folder-doc' || selectedRoute === '/TSApprove' || selectedRoute === '/LeaveApprove' || selectedRoute === '/RimApprove' || selectedRoute === '/CompOffApproval' || selectedRoute === '/MissPunchApproval' || selectedRoute === '/RequirementApprove' || selectedRoute === '/Associate-Aadhaar-EKyc' || selectedRoute === '/Aadhaar-Digilocker-Ekyc' || selectedRoute === '/Display-Details' || selectedRoute === '/LoanApprove' || selectedRoute === '/FaceRecognitionApprove') {
            this.isCareerPortal = true;
            this.isSinglePage = false;
            this.isSelfOnboardProtal = false;
          }
          else {
            const self = selectedRoute.split('/')[1];
            if (self && self === 'self-onboarding') {
              this.isSelfOnboardProtal = true;
              this.isCareerPortal = false;
              this.isSinglePage = true;
            }
            else {
              this.isCareerPortal = false;
              this.isSelfOnboardProtal = false;
              this.isSinglePage = false;
            }
          }
        }
        // console.log(this.isCareerPortal);
        // console.log(this.selRoute);

      }, 100);
    });
  }

  ngAfterViewInit(): void {
    if (this.route.url === '/login') {
      this.isCareerPortal = false;
      this.isSelfOnboardProtal = false;
      this.isSinglePage = true;
      this.selRoute = this.route.url;
    }
    this.route.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((e: any) => {
      setTimeout(() => {
        const selectedRoute = e.urlAfterRedirects.split('?')[0];
        this.selRoute = selectedRoute;
        if (selectedRoute) {
          if (selectedRoute && selectedRoute === '/associate-registration' || selectedRoute === '/job-details' || selectedRoute === '/apply-for-job' || selectedRoute === '/jobs' || selectedRoute === '/token' || selectedRoute === '/Resume-List' || selectedRoute === '/Interview-Feedback' || selectedRoute === '/Timesheet-Approval' || selectedRoute === '/Pay-Register' || selectedRoute === '/early-attendance' || selectedRoute === '/self-onboarding' || selectedRoute === '/folder-doc' || selectedRoute === '/TSApprove' || selectedRoute === '/LeaveApprove' || selectedRoute === '/RimApprove' || selectedRoute === '/CompOffApproval' || selectedRoute === '/MissPunchApproval' || selectedRoute === '/RequirementApprove' || selectedRoute === '/Associate-Aadhaar-EKyc' || selectedRoute === '/Aadhaar-Digilocker-Ekyc' || selectedRoute === '/Display-Details' || selectedRoute === '/LoanApprove' || selectedRoute === '/FaceRecognitionApprove') {
            this.isCareerPortal = true;
            this.isSinglePage = false;
            this.isSelfOnboardProtal = false;
          } else {
            const self = selectedRoute.split('/')[1];
            if (self && self === 'self-onboarding') {
              this.isSelfOnboardProtal = true;
              this.isCareerPortal = false;
              this.isSinglePage = true;
            } else {
              this.isCareerPortal = false;
              this.isSelfOnboardProtal = false;
              this.isSinglePage = false;
            }
          }
        }
      }, 100);
    });
  }

}

@NgModule({
  imports: [CommonModule, DxScrollViewModule, HeaderModule, FooterModule],
  exports: [SingleCardComponent],
  declarations: [SingleCardComponent]
})
export class SingleCardModule { }
